namespace PaperTrail.NewsletterControl {
    export interface PageTemplateSectionForm {
        Identifier: Serenity.StringEditor;
        CharactersLimit: Serenity.IntegerEditor;
        Height: Serenity.IntegerEditor;
        Width: Serenity.IntegerEditor;
        Rows: Serenity.IntegerEditor;
        Columns: Serenity.IntegerEditor;
        Rank: Serenity.IntegerEditor;
        DoPageBreak: Serenity.BooleanEditor;
        StyleSheetId: Serenity.LookupEditor;
    }

    export class PageTemplateSectionForm extends Serenity.PrefixedContext {
        static formKey = 'NewsletterControl.PageTemplateSection';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PageTemplateSectionForm.init)  {
                PageTemplateSectionForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.LookupEditor;

                Q.initFormType(PageTemplateSectionForm, [
                    'Identifier', w0,
                    'CharactersLimit', w1,
                    'Height', w1,
                    'Width', w1,
                    'Rows', w1,
                    'Columns', w1,
                    'Rank', w1,
                    'DoPageBreak', w2,
                    'StyleSheetId', w3
                ]);
            }
        }
    }
}
